import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { processAllPendingPriceChanges } from "../api/processAllPendingPriceChanges";

export const useProcessAllPendingPriceChanges = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => processAllPendingPriceChanges(),
    onSuccess: (data) => {
      const summary = data?.result?.summary || {};
      toast.success(
        `Processed ${summary.successful || 0} of ${summary.total || 0} price changes successfully!`
      );
      queryClient.invalidateQueries({ queryKey: ["pendingPriceChanges"] });
      queryClient.invalidateQueries({ queryKey: ["subscriptionDetails"] });
      queryClient.invalidateQueries({ queryKey: ["allSubscriptions"] });
    },
    onError: (error) => {
      toast.error(error.message || "Failed to process pending price changes.");
    },
  });
};

